import { Fade, Box, Typography, TextField, Button } from "@mui/material";
import { FC, useState } from "react";
import FormHelper from "../../../../../helpers/form.helper";

interface Step1Props {
    activeStep: number;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    address: string;
    handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    handleNext: () => void;
}

const Step1: FC<Step1Props> = ({
    activeStep,
    firstName,
    lastName,
    phone,
    email,
    address,
    handleChange,
    handleNext
}) => {
    const [isPhoneFocused, setIsPhoneFocused] = useState(false);
    const [isEmailFocused, setIsEmailFocused] = useState(false);

    return (
        <Fade in={activeStep === 0} unmountOnExit>
            <Box sx={{ display: activeStep === 0 ? "flex" : "none", flexDirection: "column", gap: 2 }}>
                <Typography variant="h6" fontWeight={600} color="#bfa14b" mb={1}>
                    Dane kontaktowe
                </Typography>
                <TextField
                    label="Imię"
                    name="firstName"
                    value={firstName}
                    onChange={handleChange}
                    required
                    autoFocus
                    inputMode="tel"
                />
                <TextField
                    label="Nazwisko"
                    name="lastName"
                    value={lastName}
                    onChange={handleChange}
                    required
                />
                <TextField
                    label="Nr telefonu"
                    name="phone"
                    value={phone}
                    onChange={handleChange}
                    required
                    type="tel"
                    error={!FormHelper.isPhoneNumber(phone) && phone.length > 0 && !isPhoneFocused}
                    onFocus={() => setIsPhoneFocused(true)}
                    onBlur={() => setIsPhoneFocused(false)}
                />
                <TextField
                    label="Adres e-mail"
                    name="email"
                    type="email"
                    value={email}
                    onChange={handleChange}
                    required
                    onFocus={() => setIsEmailFocused(true)}
                    onBlur={() => setIsEmailFocused(false)}
                    error={!FormHelper.isEmail(email) && email.length > 0 && !isEmailFocused}
                />
                <TextField
                    label="Adres"
                    name="address"
                    value={address}
                    onChange={handleChange}
                    required
                    multiline
                    minRows={2}
                />
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                    <Button
                        variant="contained"
                        sx={{
                            bgcolor: "#bfa14b",
                            color: "#fff",
                            fontWeight: 600,
                            px: 4,
                            borderRadius: 2,
                            boxShadow: "0 2px 8px rgba(191,161,75,0.12)",
                            "&:hover": { bgcolor: "#a88d36" }
                        }}
                        onClick={handleNext}
                        disabled={
                            !firstName || !lastName || !FormHelper.isPhoneNumber(phone) || !address || !FormHelper.isEmail(email)
                        }
                    >
                        Dalej
                    </Button>
                </Box>
            </Box>
        </Fade>
    )
}

export default Step1;